import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from '@/components/App';
import router from './router';
import store from './store';
// import $ from 'jquery';
import VueGtag from 'vue-gtag';
import VueTour from 'vue-tour';
import filters from './filters/filters';
import Spinner from './components/common/LoadingSpinner/Spinner.vue';
import VueNumber from 'vue-number-animation';

import timeTooltipPlugin from './plugins/timeTooltip';
import localStoragePlugin from './plugins/localStoragePlugin';
/* import setLocalStorageDataPlugin from './plugins/setLocalStorageDataPlugin'; */

Vue.use(timeTooltipPlugin);
Vue.use(localStoragePlugin, { persist: true });
/* Vue.use(setLocalStorageDataPlugin, { persist: true }); */

//TODO: Add Interceptors here
// importing the helper
/* import interceptorsSetup from 'Src/helpers/interceptors' */

// and running it somewhere here
/* interceptorsSetup(); */

// Vue tour lib
/* require('vue-tour/dist/vue-tour.css');*/
Vue.use(VueTour);

// Plugin imports
Vue.use(Vuelidate);

// Animating Numbers for free-job-posting
Vue.use(VueNumber);

import Toasted from 'vue-toasted';

import svgHelper from './components/common/svgHelper';

import PortalVue from 'portal-vue';
import Popper from 'vue-popperjs';

import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css';

import 'flag-icons/css/flag-icons.min.css';

import vSelect from 'vue-select';
import InfiniteLoading from 'vue-infinite-loading';

import StarRating from 'vue-star-rating';

Vue.component('Spinner', Spinner);

Vue.component('star-rating', StarRating);

Vue.use(InfiniteLoading, {
  props: {
    spinner: 'default',
    /* other props need to configure */
  },
  system: {
    throttleLimit: 50,
    /* other settings need to configure */
  },
});
/* const svg = url(
  "data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='14' height='14' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='grey'/></g></svg>",
); */

vSelect.props.components.default = () => ({
  OpenIndicator: {
    render: createElement => createElement('span'),
  },
});

/* Vue Select Field */
Vue.component('v-select', vSelect);

// Date Range Picker Global Component
Vue.use(AirbnbStyleDatepicker, {
  colors: {
    selected: '#f05a00',
    inRange: '#0088cc',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#fff',
    disabled: '#fff',
    hoveredInRange: '#0088cc',
  },
  /* ariaLabels: {
    chooseDate: date => date,
    chooseStartDate: date => `Choose ${date} as your start date.`,
    chooseEndDate: date => `Choose ${date} as your end date.`,
    selectedDate: date => `Selected. ${date}`,
    unavailableDate: date => `Not available. ${date}`,
    previousMonth: 'Move backward to switch to the previous month.',
    nextMonth: 'Move forward to switch to the next month.',
    closeDatepicker: 'Close calendar',
    openKeyboardShortcutsMenu: 'Open keyboard shortcuts menu.',
    closeKeyboardShortcutsMenu: 'Close keyboard shortcuts menu',
  }, */
});

// Toaster
Vue.use(Toasted, { iconPack: 'fontawesome' });

// Portal
Vue.use(PortalVue);

// Tooltips
Vue.component('popper', Popper);

// SVG Helper component
Vue.component('svgHelper', svgHelper);
/* Vue.use(
  VueGtag,
  {
    config: {
      id: 'GTM-KCZTWXM2',
      params: {
        send_page_view: true,
      },
    },
  },
  router,
); */
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  filters,
  validations: {},
  render: h => h(App),
}).$mount('#app');
